import React from "react";

import CreditCard from "../CreditCard";

import { TitleAndStatusContainer, Title, Close, Row, Jumbotron, JumbotronTitle, CreditCardContainer, InfoTitle, Info } from "./styles";

//Assets
import close from "../../assets/icons/close.svg";

const ModalDetails = () => {
    return (        
        <div className="modal fade" id="details-future"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-details">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between mb-0 pb-0">
                        <div>
                            <TitleAndStatusContainer>
                                <Title>Detalhes da venda</Title>
                            </TitleAndStatusContainer>
                        </div>
                        <Close data-dismiss="modal" aria-label="Close">
                            <img src={close} alt="fechar"/>
                        </Close>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Jumbotron>
                                <JumbotronTitle>Venda</JumbotronTitle>
                                <InfoTitle>VALOR</InfoTitle>
                                <Info>R$ 50,00</Info>
                                <InfoTitle>Tipo</InfoTitle>
                                <Info>Crédito à vista</Info>
                                <InfoTitle>Data de criação</InfoTitle>
                                <Info>05/07/2020</Info>
                            </Jumbotron>
                            
                            <CreditCardContainer>
                                <CreditCard id={3}/>
                            </CreditCardContainer>
                        </Row>

                        <Row>
                            <Jumbotron>
                                <JumbotronTitle>Vendedor</JumbotronTitle>
                                <InfoTitle>Nome</InfoTitle>
                                <Info>100PAY</Info>
                                <InfoTitle>CNPJ</InfoTitle>
                                <Info>99.248.512/0001-39</Info>
                                <InfoTitle>E-mail</InfoTitle>
                                <Info>contato@100pay.com.br</Info>
                                <InfoTitle>Telefone</InfoTitle>
                                <Info>(87) 79104-6145</Info>
                            </Jumbotron>
                            <Jumbotron>
                                <JumbotronTitle>Comprador</JumbotronTitle>
                                <InfoTitle>Nome</InfoTitle>
                                <Info>PAULO SILVEIRA</Info>
                                <InfoTitle>CPF/CNPJ</InfoTitle>
                                <Info>99.248.512/0001-39</Info>
                                <InfoTitle>Telefone</InfoTitle>
                                <Info>(87) 79104-6145</Info>
                            </Jumbotron>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalDetails